import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { WebGLPathDisplay, pitchTypeDisplayName, percent, ratio, mapPitchPaths } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import ReportNote from '../../../../components/ReportNote';

const PitchMovementImages = ({ repertoire, pitchCharacteristics, isLhp, levelId, pitcherId }) => {
    const { t: translate } = useTranslation();

    return (
        <ReportCard title={translate('pitcher-overview.sections.pitch-movement-images')}>
            <Row>
                {repertoire.filter((type) => type.fxtype !== 1).map((type) => {
                    const pitches = pitchCharacteristics.pitches.filter((p) => p.pitchtype === type.fxtype && p.fxsubtype === type.fxsubtype);
                    const pitchType = pitchCharacteristics.pitchtypes.find((p) => p.pitchtype === type.fxtype && p.fxsubtype === type.fxsubtype);

                    return (
                        <Col lg={3} key={`${type.fxtype}-${type.fxsubtype}`} className="mb-3">
                            <div className="border rounded p-3 h-100">
                                <div className="text-center fs-6">
                                    {pitchTypeDisplayName(type, false, false, translate)} ({percent(ratio(type.pitches, type.pitches_total), 0)})
                                </div>
                                {pitches.length
                                    ? (
                                        <div className="text-center mt-3">
                                            <WebGLPathDisplay
                                                view="catcher"
                                                height={270}
                                                width={200}
                                                pitches={mapPitchPaths(pitches, isLhp, pitchType)?.pitchpaths}
                                                disableControls
                                                showBall
                                            />
                                            <div className="mt-3">
                                                <ReportNote
                                                    type={levelId === 8 ? 'oppp' : 'mnhp'}
                                                    section={100}
                                                    playerId={pitcherId}
                                                    fxtype={type.fxtype}
                                                    fxsubtype={type.fxsubtype}
                                                    levelId={levelId}
                                                />
                                            </div>
                                        </div>
                                    )
                                    : <>{translate('sections.opponent.player.not-enough-data')}</>}
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </ReportCard>
    );
};

export default PitchMovementImages;
